// document.addEventListener('click', (event) => {
//   const checkoutButton = document.querySelector('button.checkout-options__button--single');
//   if (checkoutButton.contains(event.target) && window.hulkapps != undefined && is_draft_order) {
//     event.preventDefault();
//     event.stopPropagation();
//     event.stopImmediatePropagation();
//     hulkappsCheckout();
//   }
// }, true);
document.addEventListener('click', async (event) => {
  const checkoutButton = document.querySelector('button.checkout-options__button--single');
  if (!checkoutButton || !checkoutButton.contains(event.target)) return;
  if (window.hulkapps == undefined || typeof is_draft_order === 'undefined' || !is_draft_order) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  // Hulk's draft-order checkout bypasses the native cart form, so the dispatch
  // date (a hidden cart-form attribute) must be saved to the cart first or it
  // never reaches the order. stopImmediatePropagation also skips the cart
  // footer's own validation, so re-check the date here.
  if (typeof window.ebGetDispatchDate === 'function' && !window.ebGetDispatchDate()) {
    alert('Please select a dispatch date before checking out.');
    return;
  }
  if (checkoutButton.disabled) return;
  checkoutButton.disabled = true;

  // A blank multi_ship clears any stale flag left by an earlier "Ship to
  // multiple addresses" click; this is a single-address checkout.
  if (typeof window.ebPersistDispatchDate === 'function') {
    await window.ebPersistDispatchDate({ multi_ship: '' });
  }
  hulkappsCheckout();
}, true);

